﻿import Valg from '../../../Shared/Scripts/Models/Valg';

export interface ValgState {
    aUtdanning?: Valg<string>;
    bVerdensdel?: Valg<string>;
    cLand?: Valg<string>;
    dSkolepenger?: Valg<string>;
    eUniversitetUtvidetStipend?: Valg<string>;
    gAntallAr?: Valg<number>;
    visUtbetalingsplan: boolean;
}

export const UPDATE_VALG = 'UPDATE_AVALG';

interface UpdateValgAction {
    type: typeof UPDATE_VALG;
    payload: Partial<ValgState>;
}

export type ValgStateActionTypes = UpdateValgAction;
